export default {
  apiToken: (state) => state.apiToken,
};
